import React, { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from './ProductItem';
import Filter from '../../hocs/Filter/Filter';
import Top from '../Top/Top';
import TemplateParser from '../Templates/TemplateParser';
import { origin } from '../../config';
import { addEvent, removeEvent } from '../../utils/dom';
import { prefix } from '../../utils/locale';
import s from './Category.scss';

const Category = ({ data, currentPath, setup, productCache, filter }) => {
	if (!data) return null;

	const [productLayout, updateProductLayout] = useState('list');
	const parts = data?.parts || [];
	const contentSections = [];
	const cmsSections = {};
	const bottomSections = [];

	useEffect(() => {
		const updateLayoutOnResize = () => {
			if (window.innerWidth > 600 && productLayout === 'list') {
				updateProductLayout('expanded');
			}
		};

		addEvent(window, 'resize.categoryLayout', () => {
			window.requestAnimationFrame(updateLayoutOnResize);
		});

		updateLayoutOnResize();

		return () => {
			removeEvent(window, 'resize.categoryLayout');
		};
	}, [productLayout]);

	const flattenCMSSections = (sections, uri = '') => {
		Object.keys(sections).forEach((section) => {
			if (sections[section].localized && sections[section].localized[setup.language]) {
				cmsSections[`${uri}${sections[section].localized[setup.language].uri}`] = sections[section];
			} else {
				cmsSections[`${uri}${section}`] = sections[section];
			}
			if (sections[section].subCategories) {
				flattenCMSSections(sections[section].subCategories, `${uri}${section}/`);
			}
		});
	};
	flattenCMSSections(data?.subCategoryCMSData || {});

	parts.forEach((section) => {
		const insertPosition = section?.partsMeta?.priority || 0;

		// If conflicting parts then take the first version.
		if (parseInt(insertPosition, 10) < 0) {
			if (bottomSections[Math.abs(insertPosition)]) {
				bottomSections[bottomSections.length] = section;
			} else {
				bottomSections[Math.abs(insertPosition)] = section;
			}
		} else if (parseInt(insertPosition, 10) > 0) {
			if (!cmsSections.default) cmsSections.default = { parts: [] };
			cmsSections.default.parts[cmsSections.default.parts.length] = section;
		} else if (contentSections[insertPosition]) {
			contentSections[contentSections.length] = section;
		} else {
			contentSections[insertPosition] = section;
		}
	});

	data.content.linkCanonical = `${origin}${prefix(setup, currentPath)}`;

	/*
	const productLayoutHandler = (e) => {
		const toLayout = e.currentTarget.value;
		updateProductLayout(toLayout);
	};
	*/

	return (
		<main role="main" className={[s.category, `u_category__${productLayout}`].join(' ')}>
			<Top setup={setup} pageContent={data.content} paths={data.paths} />
			{
				contentSections.map((section, i) => {
					if (section === undefined) return null;
					return <TemplateParser key={i} sections={section.sections} setup={setup} />;
				})
			}
			<Filter ListComponent={ProductItem} filter={filter} data={data} setup={setup} currentPath={currentPath} cmsSections={cmsSections} productLayout={productLayout} />
			{
				bottomSections.map((section, i) => {
					if (section === undefined) return null;
					return <TemplateParser key={i} sections={section.sections} setup={setup} />;
				})
			}
		</main>
	);
};

const mapState = ({ environment, filter }, { data, currentPath }) => ({
	data,
	currentPath,
	setup: environment.setup,
	filter,
});

export default hot(module)(connect(mapState)(Category));
